import React from "react";
import { cn } from "../../lib/utils";

export function StickerCard({ children, className, ...props }) {
  return (
    <div
      className={cn(
        "bg-white border-4 border-white rounded-[2rem] shadow-playful relative overflow-hidden",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
